import { useState } from 'react';
import { MapContainer, Marker, TileLayer, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png'
});

export function Field({ label, children }) {
  return (
    <label className="dev-field">
      <span>{label}</span>
      {children}
    </label>
  );
}

export function TextInput({ value, onChange, placeholder = '', type = 'text', required = false, ...props }) {
  return (
    <input
      className="dev-input"
      type={type}
      value={value || ''}
      required={required}
      placeholder={placeholder}
      {...props}
      onChange={(event) => onChange(event.target.value)}
    />
  );
}

export function TextArea({ value, onChange, placeholder = '' }) {
  return (
    <textarea
      className="dev-textarea"
      value={value || ''}
      placeholder={placeholder}
      onChange={(event) => onChange(event.target.value)}
    />
  );
}

export function Select({ value, onChange, children }) {
  return (
    <select className="dev-input" value={value || ''} onChange={(event) => onChange(event.target.value)}>
      {children}
    </select>
  );
}

export function FileUpload({ label, type, onUpload, busy }) {
  const [file, setFile] = useState(null);
  const [docType, setDocType] = useState(type);

  const submit = async (event) => {
    event.preventDefault();
    if (!file) return;
    const fd = new FormData();
    fd.append('type', docType);
    fd.append('file', file);
    await onUpload(fd);
    setFile(null);
    event.target.reset();
  };

  return (
    <form className="dev-upload" onSubmit={submit}>
      <Field label={label}>
        <input className="dev-input" type="file" onChange={(event) => setFile(event.target.files?.[0] || null)} />
      </Field>
      <Field label="نوع مدرک">
        <Select value={docType} onChange={setDocType}>
          <option value="CERTIFICATE">گواهی</option>
          <option value="IDENTIFICATION">هویتی</option>
          <option value="CONTRACT">قرارداد</option>
          <option value="LICENCES">مجوز</option>
          <option value="PERMIT">پروانه</option>
          <option value="OWNERSHIP">مالکیت</option>
          <option value="IMAGE">تصویر پروژه</option>
          <option value="OTHER">سایر</option>
        </Select>
      </Field>
      <button className="dev-btn secondary" disabled={!file || busy}>بارگذاری</button>
    </form>
  );
}

function MapClickHandler({ onLocationSelect }) {
  useMapEvents({
    click: (event) => {
      onLocationSelect(event.latlng.lat, event.latlng.lng);
    }
  });
  return null;
}

export function ProjectLocationMap({ latitude, longitude, onChange }) {
  const lat = Number(latitude);
  const lng = Number(longitude);
  const hasPoint = Number.isFinite(lat) && Number.isFinite(lng);
  const selectedPosition = hasPoint ? [lat, lng] : [35.6892, 51.3890];

  const handleLocationSelect = (newLat, newLng) => {
    onChange({
      latitude: newLat.toFixed(6),
      longitude: newLng.toFixed(6)
    });
  };

  return (
    <div className="dev-map-picker">
      <div className="dev-map-container">
        <MapContainer
          center={selectedPosition}
          zoom={13}
          className="dev-map"
          key={`${selectedPosition[0]}-${selectedPosition[1]}`}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
          <MapClickHandler onLocationSelect={handleLocationSelect} />
          <Marker position={selectedPosition} />
        </MapContainer>
      </div>
      <p className="dev-muted">روی نقشه کلیک کنید تا موقعیت پروژه ثبت شود.</p>
    </div>
  );
}
